type MapKey<T> = keyof T;
type MapValue<T, K extends keyof T = keyof T> = T[K];

const APP_MONIKERS = {
	innovyze: 'INNOVYZE',
	// info360
	i360a: 'I360A',
	i360i: 'I360I',
	i360e: 'I360E',
	i360cs: 'I360CS',
	// waterlifecycle
	wlc360p: 'WLC360P',
	wlc360a: 'WLC360A', // (asset)
	wlc360i: 'WLC360I', // (insight)
	wlc360ai: 'WLC360AI', // (plant)
} as const;

const APP_ENVS = {
	dev: 'C',
	qa: 'S',
	prod: 'P',
} as const;

const APP_REGIONS = {
	'us-west-2': 'UW2',
	'eu-west-2': 'EW2',
	'ap-southeast-2': 'AS2',
} as const;

type KP<T> = { key: MapKey<T>; value: MapValue<T> };

type MonikerKp = KP<typeof APP_MONIKERS>;
type EnvKp = KP<typeof APP_ENVS>;
type RegionKp = KP<typeof APP_REGIONS>;

type ConstructedMonikerUrl =
	`${MonikerKp['value']}-${EnvKp['value']}-${RegionKp['value']}`;

export const constructAdskMoniker = (
	monikerName: MonikerKp['key'],
	envName: EnvKp['key'],
	regionName: RegionKp['key'],
): ConstructedMonikerUrl => {
	return `${APP_MONIKERS[monikerName]}-${APP_ENVS[envName]}-${APP_REGIONS[regionName]}`;
};
